export default "__VITE_ASSET__DdZRlpcv__"